import colors from 'vuetify/lib/util/colors'

export default {
  primary: "#b00c0e",
  secondary: "#f1861b",
  tertiary: '#fff',
  accent: "#b00c0e",
  error: "#ae4bff",
  // error: "#e61c1c", // default #bc2025
  info: '#2196F3',
  success: '#4CAF50',
  warning: '#FFC107',
}